import { Action } from 'redux';
import { Moment } from 'moment';
import * as moment from 'moment';

import { SET_DATE_FROM, SET_DATE_TO, SET_DATE_FORMAT_TEXT } from '../../actions/Afisha/date';
import i18next from 'i18next';

export interface DateAfishaState {
    dateFrom: Moment;
    dateTo: Moment | null;
    dateFormatText: string;
}

const initialState: DateAfishaState = {
    dateFrom: moment().startOf('day'),
    dateTo: null,
    dateFormatText: i18next.t('for_all_the_time')
};

export function dateAfisha(state: DateAfishaState = initialState, action: Action) {
    switch (action.type) {
        case SET_DATE_FROM: {
            const dateFrom = (action as any).dateFrom;
            return {
                ...state,
                dateFrom
            };
        }
        case SET_DATE_TO: {
            const dateTo = (action as any).dateTo;
            return {
                ...state,
                dateTo
            };
        }
        case SET_DATE_FORMAT_TEXT: {
            const dateFormatText = (action as any).dateFormatText;
            return {
                ...state,
                dateFormatText
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/Afisha/date.ts